import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function TokenSaver() {
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    const userType = query.get('userType');
    const action = query.get('action');
    const customerId = query.get('customerId');
    const loginUserId = query.get('loginUserId');
    const loginUserToken = query.get('loginUserToken')

    if (token) {
      sessionStorage.setItem("token", token);
    }
    if (userType) {
      sessionStorage.setItem("userType", userType);
      localStorage.removeItem("token")
    }

    if(action){
      sessionStorage.setItem("action", action);
    }
    if(customerId){
      sessionStorage.setItem("customerId", customerId);

    }
    if(loginUserId){
      sessionStorage.setItem("loginUserId", loginUserId);
    }
    if(loginUserToken){
      sessionStorage.setItem("loginUserToken", loginUserToken);
    }
  }, [location]);

  return null;
}
